import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Style from 'ol/style/Style';
import Text from 'ol/style/Text';

interface MarkerFeatureStyleProps {
  icon: string;
  text: string;
  iconFillColor?: string;
  iconStrokeColor?: string;
  iconStrokeWidth?: number;
  textColor?: string;
}

export function markerFeatureStyle({
  icon,
  text,
  iconFillColor = '#FFFFFF',
  iconStrokeColor = '#000000',
  iconStrokeWidth = 0,
  textColor = 'rgba(0, 0, 0, 0)',
}: MarkerFeatureStyleProps): Style[] {
  return [
    // Icon to the left of the text
    new Style({
      zIndex: 1000,
      text: new Text({
        text: icon,
        font: '26px "grammar-icons"',
        fill: new Fill({ color: iconFillColor }),
        stroke:
          iconStrokeWidth > 0
            ? new Stroke({ color: iconStrokeColor, width: iconStrokeWidth })
            : undefined,
        textAlign: 'center',
        textBaseline: 'middle',
      }),
    }),
    // This is a hack to get a rounded corner around a background fill (https://github.com/openlayers/openlayers/issues/11013)
    new Style({
      zIndex: 1000,
      text: new Text({
        text,
        font: 'normal 400 16px/16px "Source Sans Pro"',
        fill: new Fill({ color: textColor }),
        offsetX: 20,
        offsetY: 0,
        textAlign: 'left',
        textBaseline: 'middle',
        backgroundStroke: new Stroke({
          color: 'rgba(15, 28, 36, 1)',
          width: 6,
          lineCap: 'round',
          lineJoin: 'round',
        }),
      }),
    }),
    // Normal text that is displayed on top of the rounded corner hack.
    new Style({
      zIndex: 1000,
      text: new Text({
        text,
        font: 'normal 400 16px/16px "Source Sans Pro"',
        fill: new Fill({ color: 'rgba(255, 255, 255, 1)' }),
        offsetX: 20,
        offsetY: 1,
        textAlign: 'left',
        textBaseline: 'middle',
        backgroundFill: new Fill({ color: 'rgba(15, 28, 36, 1)' }),
      }),
    }),
  ];
}
